// proto/v2/expertise/expertise.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file expertise/expertise.proto (package lvdr.v2.expertise, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file expertise/expertise.proto.
 */
export const file_expertise_expertise: GenFile = /*@__PURE__*/
  fileDesc("ChlleHBlcnRpc2UvZXhwZXJ0aXNlLnByb3RvEhFsdmRyLnYyLmV4cGVydGlzZSIVChNHZXRFeHBlcnRpc2VSZXF1ZXN0IsABChZVcGRhdGVFeHBlcnRpc2VSZXF1ZXN0EhcKD2V4cGVydGlzZV9hcmVhcxgBIAMoCRJWCg90b3BpY19vdmVycmlkZXMYAiADKAsyPS5sdmRyLnYyLmV4cGVydGlzZS5VcGRhdGVFeHBlcnRpc2VSZXF1ZXN0LlRvcGljT3ZlcnJpZGVzRW50cnkaNQoTVG9waWNPdmVycmlkZXNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBIrYBChFFeHBlcnRpc2VSZXNwb25zZRIXCg9leHBlcnRpc2VfYXJlYXMYASADKAkSUQoPdG9waWNfb3ZlcnJpZGVzGAIgAygLMjgubHZkci52Mi5leHBlcnRpc2UuRXhwZXJ0aXNlUmVzcG9uc2UuVG9waWNPdmVycmlkZXNFbnRyeRo1ChNUb3BpY092ZXJyaWRlc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAEiGAoWTGlzdEtub3duVG9waWNzUmVxdWVzdCJ2CgpLbm93blRvcGljEgwKBG5hbWUYASABKAkSDgoGc291cmNlGAIgASgJEhIKCmNvbmZpZGVuY2UYAyABKAESDgoGYWN0aW9uGAQgASgJEhAKCG92ZXJyaWRlGAUgASgJEhQKDGhhc19vdmVycmlkZRgGIAEoCCJEChNLbm93blRvcGljc1Jlc3BvbnNlEi0KBnRvcGljcxgBIAMoCzIdLmx2ZHIudjIuZXhwZXJ0aXNlLktub3duVG9waWNCKlooZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL2V4cGVydGlzZWIGcHJvdG8z");

/**
 * GetExpertiseRequest fetches the caller's expertise (areas + topic overrides).
 * User identity is taken from the authenticated WS connection, not the request.
 *
 * @generated from message lvdr.v2.expertise.GetExpertiseRequest
 */
export type GetExpertiseRequest = Message<"lvdr.v2.expertise.GetExpertiseRequest"> & {
};

/**
 * Describes the message lvdr.v2.expertise.GetExpertiseRequest.
 * Use `create(GetExpertiseRequestSchema)` to create a new message.
 */
export const GetExpertiseRequestSchema: GenMessage<GetExpertiseRequest> = /*@__PURE__*/
  messageDesc(file_expertise_expertise, 0);

/**
 * @generated from message lvdr.v2.expertise.UpdateExpertiseRequest
 */
export type UpdateExpertiseRequest = Message<"lvdr.v2.expertise.UpdateExpertiseRequest"> & {
  /**
   * @generated from field: repeated string expertise_areas = 1;
   */
  expertiseAreas: string[];

  /**
   * action: "skip" | "shallow" | "remove"
   *
   * @generated from field: map<string, string> topic_overrides = 2;
   */
  topicOverrides: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.expertise.UpdateExpertiseRequest.
 * Use `create(UpdateExpertiseRequestSchema)` to create a new message.
 */
export const UpdateExpertiseRequestSchema: GenMessage<UpdateExpertiseRequest> = /*@__PURE__*/
  messageDesc(file_expertise_expertise, 1);

/**
 * @generated from message lvdr.v2.expertise.ExpertiseResponse
 */
export type ExpertiseResponse = Message<"lvdr.v2.expertise.ExpertiseResponse"> & {
  /**
   * @generated from field: repeated string expertise_areas = 1;
   */
  expertiseAreas: string[];

  /**
   * @generated from field: map<string, string> topic_overrides = 2;
   */
  topicOverrides: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.expertise.ExpertiseResponse.
 * Use `create(ExpertiseResponseSchema)` to create a new message.
 */
export const ExpertiseResponseSchema: GenMessage<ExpertiseResponse> = /*@__PURE__*/
  messageDesc(file_expertise_expertise, 2);

/**
 * Known topics merge user expertise + memory topics with overrides applied.
 *
 * @generated from message lvdr.v2.expertise.ListKnownTopicsRequest
 */
export type ListKnownTopicsRequest = Message<"lvdr.v2.expertise.ListKnownTopicsRequest"> & {
};

/**
 * Describes the message lvdr.v2.expertise.ListKnownTopicsRequest.
 * Use `create(ListKnownTopicsRequestSchema)` to create a new message.
 */
export const ListKnownTopicsRequestSchema: GenMessage<ListKnownTopicsRequest> = /*@__PURE__*/
  messageDesc(file_expertise_expertise, 3);

/**
 * @generated from message lvdr.v2.expertise.KnownTopic
 */
export type KnownTopic = Message<"lvdr.v2.expertise.KnownTopic"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * "expertise" | "memory"
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: double confidence = 3;
   */
  confidence: number;

  /**
   * "skip" | "shallow"
   *
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * empty string = no override
   *
   * @generated from field: string override = 5;
   */
  override: string;

  /**
   * distinguishes empty override from absent
   *
   * @generated from field: bool has_override = 6;
   */
  hasOverride: boolean;
};

/**
 * Describes the message lvdr.v2.expertise.KnownTopic.
 * Use `create(KnownTopicSchema)` to create a new message.
 */
export const KnownTopicSchema: GenMessage<KnownTopic> = /*@__PURE__*/
  messageDesc(file_expertise_expertise, 4);

/**
 * @generated from message lvdr.v2.expertise.KnownTopicsResponse
 */
export type KnownTopicsResponse = Message<"lvdr.v2.expertise.KnownTopicsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.expertise.KnownTopic topics = 1;
   */
  topics: KnownTopic[];
};

/**
 * Describes the message lvdr.v2.expertise.KnownTopicsResponse.
 * Use `create(KnownTopicsResponseSchema)` to create a new message.
 */
export const KnownTopicsResponseSchema: GenMessage<KnownTopicsResponse> = /*@__PURE__*/
  messageDesc(file_expertise_expertise, 5);

